import React, { useEffect } from "react";
import GoogleButton from "react-google-button";
import loginSplash from "../../assets/png/loginSplash.png";
import { useDispatch, useSelector } from "react-redux";
import { setFirebaseUser } from "../../reducers/user";
import { QuantumLogoIcon } from "../../assets/icons/QuantumLogoIcon";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import auth from "../../utils/firebase";
import "./Login.css";
import { useNavigate } from "react-router";
import { setPageLoading, setSignInErrorMessage } from "../../reducers/app";
import { signInErrorMessageSelector } from "../../reducers/app/selector";

const googleProvider = new GoogleAuthProvider();

const addresses = process.env.REACT_APP_ACCEPTED_ADDRESSES.split(" ");

const verifyDPDEmail = (email) => {
  const splitEmail = email.split("@");
  const address = splitEmail[splitEmail.length - 1];
  return addresses.includes(address);
};

export const Login = () => {
  const signInErrorMessage = useSelector(signInErrorMessageSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setPageLoading(false));
  }, [dispatch]);

  const signInApp = async () => {
    try {
      dispatch(setPageLoading(true));
      const credentials = await signInWithPopup(auth, googleProvider);
      const user = credentials.user;
      if (verifyDPDEmail(user.email)) {
        const claims = JSON.parse(
          user.reloadUserInfo.customAttributes
        ).adminMatrix;
        if (claims) {
          dispatch(setFirebaseUser(user));
          dispatch(setSignInErrorMessage(""));
          navigate("/");
        } else {
          dispatch(setSignInErrorMessage("Insufficient permissions"));
          dispatch(setPageLoading(false));
          await auth.signOut();
        }
      } else {
        dispatch(setSignInErrorMessage("Email domain not accepted"));
        dispatch(setPageLoading(false));
        await auth.signOut();
      }
    } catch (err) {
      dispatch(setSignInErrorMessage("Sign in failed"));
      dispatch(setPageLoading(false));
      await auth.signOut();
    }
  };

  return (
    <div
      className="loginContainer"
      style={{
        backgroundImage: `linear-gradient(180deg, #A90034 0%, rgba(220, 0, 50, 0.2) 100%), url(${loginSplash})`,
      }}
    >
      <QuantumLogoIcon />
      <GoogleButton onClick={signInApp} />
      {signInErrorMessage && (
        <p className="loginErrorMessage">{signInErrorMessage}</p>
      )}
    </div>
  );
};
